import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Users, Plus, X } from 'lucide-react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const WitnessInformation = ({ expanded, onToggle, formData, setFormData }) => {
  const [newWitness, setNewWitness] = useState({ name: '', contact: '', statement: '' });

  const addWitness = () => {
    if (newWitness?.name && newWitness?.contact) {
      setFormData(prev => ({
        ...prev,
        witnesses: [...prev?.witnesses, { ...newWitness, key: Date.now() }]
      }));
      setNewWitness({ name: '', contact: '', statement: '' });
    }
  };

  const removeWitness = (key) => {
    setFormData(prev => ({
      ...prev,
      witnesses: prev?.witnesses?.filter(w => w?.key !== key)
    }));
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer hover:bg-gray-50"
        onClick={onToggle}
      >
        <div className="flex items-center gap-3">
          <Users className="w-5 h-5 text-blue-600" />
          <h2 className="text-lg font-semibold text-gray-900">Witness Information</h2>
        </div>
        {expanded ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
      </div>
      {expanded && (
        <div className="p-4 pt-0 border-t border-gray-200">
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <Input
                placeholder="Witness Name"
                value={newWitness?.name}
                onChange={(e) => setNewWitness(prev => ({ ...prev, name: e?.target?.value }))}
              />
              <Input
                placeholder="Contact Information"
                value={newWitness?.contact}
                onChange={(e) => setNewWitness(prev => ({ ...prev, contact: e?.target?.value }))}
              />
            </div>

            <div>
              <textarea
                placeholder="Witness statement (optional - can be collected during investigation)"
                value={newWitness?.statement}
                onChange={(e) => setNewWitness(prev => ({ ...prev, statement: e?.target?.value }))}
                rows={3}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>

            <Button
              type="button"
              onClick={addWitness}
              className="flex items-center gap-2"
              disabled={!newWitness?.name || !newWitness?.contact}
            >
              <Plus className="w-4 h-4" />
              Add Witness
            </Button>

            {formData?.witnesses?.length > 0 && (
              <div className="space-y-2">
                <h4 className="text-sm font-medium text-gray-700">Added Witnesses:</h4>
                {formData?.witnesses?.map((witness) => (
                  <div 
                    key={witness?.key} 
                    className="bg-gray-50 rounded-lg p-3"
                  >
                    <div className="flex items-start justify-between mb-2">
                      <div>
                        <p className="text-sm font-medium text-gray-900">{witness?.name}</p>
                        <p className="text-xs text-gray-600">{witness?.contact}</p>
                      </div>
                      <button
                        type="button"
                        onClick={() => removeWitness(witness?.key)}
                        className="text-red-600 hover:text-red-800"
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                    {witness?.statement && (
                      <p className="text-sm text-gray-700 mt-2">{witness?.statement}</p>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default WitnessInformation;